export default __webpack_public_path__ + "static/media/lets_tap.15a31ed4.png";